import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

import app from './modules/app'
import fermenters from './modules/fermenters'
import tankGroups from './modules/tank-groups'
import sites from './modules/sites'
import settings from './modules/settings'
import simulatorSetup from './modules/simulator-setup'
import profiles from './modules/profiles'
import ferments from './modules/ferments'
import simulator from './modules/simulator'
import user from './modules/user'

export default new Vuex.Store({
	modules: {
		app,
		fermenters,
		tankGroups,
		sites,
		settings,
		simulatorSetup,
		profiles,
		ferments,
		simulator,
		user
	}
});



// WEBPACK FOOTER //
// ./src/vuex/store.js